import axios from "axios";
import { tokenConfig } from "./auth";

import { GET_ROLES } from "./types";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const getRoles = () => (dispatch, getState) => {
  axios
    .get(BASE_URL + `/role/list`, tokenConfig(getState))
    .then((res) => {
      dispatch({
        type: GET_ROLES,
        payload: res.data.data,
      });
    })
    .catch((err) => console.error(err));
};
